<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">Produkty</h3>
        <div class="d-flex flex-row gap-3 flex-fill justify-content-end">
            <input #imgInput hidden="true" type="file" onclick="this.value=null" (change)="imgInputChange($event)"
                accept="image/*" />
            <button mat-flat-button color="accent" (click)="imgInput.click()">
                Wybierz zdjęcie
            </button>
        </div>
    </div>
    {{productsCount}} CBDOK
    <div class="content-div">
        <div class="input-div">
            <div class="input-field d-flex flex-row flex-wrap pb-2">
                <mat-form-field class="w-100">
                    <mat-label>
                        Wprowadź kod ean
                    </mat-label>
                    <input matInput 
                    [formControl]="eanCode" 
                    maxlength="13" 
                    (keypress)="blockNumbers($event)" 
                    (keydown.enter)="checkProductByEan(eanCode.value)">

                </mat-form-field>

                <button mat-flat-button (click)="checkProductByEan(eanCode.value)">Sprawdź</button>
            </div>

            <div class="output-field" *ngIf="productExists.message">
                <span>{{productExists!.message}}</span>
                <div class="product-object" *ngIf="productExists.exists">
                    <table class="table table-dark table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">Parametr</th>
                                <th scope="col">Wartość</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">EAN</th>
                                <td>{{product?.ean}}</td>
                            </tr>
                            <tr>
                                <th scope="row">Nazwa</th>
                                <td>{{product?.product_name_long}}</td>
                            </tr>
                            <tr>
                                <th scope="row">Typ</th>
                                <td>{{product?.package_type}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div>
             <div class="input-field d-flex flex-row flex-wrap pb-2">
                <mat-form-field class="w-100">
                    <mat-label>
                        Wprowadź nazwę produktu
                    </mat-label>
                    <input matInput [formControl]="nameInput" (keydown.enter)="checkProductByName(nameInput.value)">

                </mat-form-field>

                <button mat-flat-button (click)="checkProductByName(nameInput.value)">Sprawdź</button>
            </div>
            <div class="output-field" *ngIf="productsList && productsList.length > 0">
                <div class="product-object" >
                    <table class="table table-dark table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">EAN</th>
                                <th scope="col">NAZWA</th>
                                <th scope="col">TYP</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let prod of productsList">
                                <td>{{prod?.ean}}</td>
                                <td>{{prod?.product_name_long}}</td>
                                <td>{{prod?.package_type}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngIf="nameExistMessage">
                Produkt o nazwie {{nameExistMessage}} nie istnieje w bazie CBDOK
            </div>
        </div>
    </div>
</div>